// import { useRouter } from 'next/router'
import { BrowserRouter as Router, Link, NavLink, useLocation } from "react-router-dom";
// import { NavHashLink } from 'react-router-hash-link';
import { DisplayRoute } from "../routes";
// import Image from 'next/image'
import { atom, useAtom } from 'jotai'
import _ from "lodash"
import { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react'

// import { isSmallAtom } from "../atoms";
import {isSmallAtom} from '../atoms/atom.config.js'

import useDeviceSize from '../components/useDeviceSize';
import { mobileWidth } from '../constants';
import {OutlineButtonTextIcon, ButtonTextIcon} from '../components/Button'

// assets
//import logoImage from '../assets/images/default_thumb.jpg' //button_mobile_menu.svg
// import logoImage2 from './default_thumb.jpg'
//import scrollDownIcon from '../assets/icons/icon_scrolldown.svg'
import menuIcon from '../assets/icons/icon_menu.svg'
import closeIcon from '../assets/icons/icon_close.svg'
// import logoIcon from '../assets/icons/logo_RBA3.svg'
// import logoIcon from '../assets/icons/logo_desktop.svg'
import logoIconMobile from '../assets/icons/logo_mobile.svg'
import helpIcon from "../assets/icons/icon_help.svg"



const MobileMenu = forwardRef((props,ref) => {
// export default function MobileMenu(props) {
  //console.log(props);
  // const router = useRouter()
  //const names = ['Ada Lovelace', 'Grace Hopper', 'Margaret Hamilton'];

  //const [isSmall, setIsSmall] = useAtom(isSmallAtom);
  //const [showMenu, setShowMenu] = useState(true);
  //const [showMenu, setShowShareModal] = useAtom(showShareModalAtom);

  //const [width, height] = useDeviceSize();

  const [isFadingOut, setIsFadingOut] = useState(false);
  const {pathname} = useLocation(); 

  const fadeOut = () => {
    if(isFadingOut) return;

    setIsFadingOut(true);
    // need a timeout here to remove the menu
    //{()=>fadeOut(setTimeout(()=>handleRemoveItem(),300))}
    setTimeout(() => {
      props.onMenuClose()
      setIsFadingOut(false);
    },210);
  };

  const fadeIn = () => {
    if(!isFadingOut) return;

    setIsFadingOut(false);
  };

  const forceReload = () => {
    console.log("FORCE RELOAD if on same/intro page!", pathname)
    window.location.reload();
  };

  useImperativeHandle(ref, () => {
    return { 
      //gotoSlideMod: (slideIndex) => gotoSlide(slideIndex),
      fadeOutMod: () => fadeOut()
    }
  });

  useEffect(() => {
    console.log("MobileMenu:")
    //setIsFadingOut(false); 
  }, []);

  const highlighted = `underline decoration-2 underline-offset-8 w-full grow-0`;
  const nonHighlighted = `w-full grow-0`;
  const cn = `block fixed w-screen h-screen top-0 z-[999] pointer-events-auto bg-rba-gray-options ${(isFadingOut) ? 'animate-fadeout' : 'animate-fadein'}`;
  //const cn = `flex flex-col w-full min-h-displayHt items-center justify-center text-center relative ${props.className}`;
  return (
    //     // <div className="block fixed w-screen h-screen top-0 z-[999] bg-gray-500 animate-fadein" id="menu">
      <div className={cn} id="menu">
        <div className="flex flex-col justify-center items-center font-bold mx-8 gap-y-5 h-full text-2xl cursor-pointer pointer-events-auto">
            <div className="grow"></div>
            {/* <NavLink to="/" className={({ isActive }) => isActive ? highlighted : undefined}>Introduction</NavLink> */}
            <NavLink tabIndex="4" to="/" end onClick={ pathname == "/" ? forceReload : null} className={({ isActive }) => isActive ? highlighted : nonHighlighted}>Introduction</NavLink>
            {/* <Link to="/about">About</Link> */}
            <NavLink tabIndex="5" to="/five" onClick={ pathname == "/five" ? forceReload : null} className={({ isActive }) => isActive ? highlighted : nonHighlighted}>$5</NavLink>
            <NavLink tabIndex="6" to="/ten" onClick={ pathname == "/ten" ? forceReload : null} className={({ isActive }) => isActive ? highlighted : nonHighlighted}>$10</NavLink>
            <NavLink tabIndex="7" to="/twenty" onClick={ pathname == "/twenty" ? forceReload : null} className={({ isActive }) => isActive ? highlighted : nonHighlighted}>$20</NavLink>
            <NavLink tabIndex="8"  to="/fifty" onClick={ pathname == "/fifty" ? forceReload : null} className={({ isActive }) => isActive ? highlighted : nonHighlighted}>$50</NavLink>
            <NavLink tabIndex="9"  to="/hundred" onClick={ pathname == "/hundred" ? forceReload : null} className={({ isActive }) => isActive ? highlighted : nonHighlighted}>$100</NavLink>
            <button tabIndex="10"  className={nonHighlighted} onClick={props.onHelpClicked} ><img src={helpIcon} className="w-[28px] h-[28px] mx-auto" alt="Help" /></button>
            <div className="grow"></div>
        </div>
        <div className="block fixed w-screen top-0 pt-6 pointer-events-auto">
          <div className="flex justify-start items-center">
            <div className="mx-5 w-[70px] cursor-pointer pointer-events-auto">
              {/* <NavLink to="/" onClick={ pathname == "/" ? forceReload : null}>
              <img src={logoIcon} className="" alt="RBA Logo"  />
              </NavLink> */}
              <a href="https://museum.rba.gov.au/"><img src={logoIconMobile} className="" alt="Reserve Bank of Australia"  /> </a>
            </div>
            <div className="flex grow"></div>
            {/* <div className='w-full text-xl font-bold text-center'><h3></h3></div> */}
            {/*   onClick={ props.onMenuClose} */}
            <button tabIndex="11" className="flex flex-none justify-end mx-5 mt-[-28px] w-[28px] cursor-pointer pointer-events-auto " onClick={fadeOut} >
              <img src={closeIcon} alt="close" width={28} height={28}/>
            </button>
          </div>
        </div>
    </div>
  )
})

export {
  MobileMenu
}